export function Egallery() {
    return (
        <section className="gallery-main-section">
            <div className="gallery-img">
                <p>Development of international processes for opening branches abroad.</p>
            </div>
            <div className="gallery-img">
                <p>Supply and installation of residential and industrial air conditioning systems.</p>
            </div>
            <div className="gallery-img">
                <p>Design of air conditioning installation diagrams</p>
            </div>
            <div className="gallery-img">
                <p>Planning of infrastructure for industrial plants.
                </p>
            </div>
            <div className="gallery-img">
                <p>Mantaining and reparation of air conditioning systems.</p>
            </div>
            <div className="gallery-img">
                <p>VRV & VRF Systems</p>
            </div>
            <div className="gallery-img">
                <p>Industrial Dust Collection Systems</p>
            </div>
        </section>
    )
}